<br>
<br>
<br>
<div class="p-2">
  <div class="container-fluid">
    <div class="row">
      <div class=".col-xs-6 .col-sm-3 ">
        <h5 [ngClass]="'text-'+globals.colorTheme">
          <i class="fas fa-book"></i> Approvals</h5>
      </div>

      <div class=".col-xs-6 .col-sm-3 ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
      <div class=".col-xs-6 .col-sm-3 ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>

      <div class=".col-xs-6 .col-sm-3">
        <button class="btn btn-outline-success btn-sm" data-toggle="collapse" data-target="#demo">
          <i class="fas fa-cog"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<div id="demo" class="container pull-right collapse">
  <div class="btn-group btn-group-toggle pull-right" data-toggle="buttons">
    <label class="btn btn-outline-success btn-sm active" (click)="changeStatus('pending');">
      <input type="radio" name="options" id="pending" autocomplete="off" checked> Pending
    </label>
    <label class="btn btn-outline-success btn-sm" (click)="changeStatus('approved');">
      <input type="radio" name="options" id="approved" autocomplete="off"> Approved
    </label>
    <label class="btn btn-outline-success btn-sm" (click)="changeStatus('rejected');">
      <input type="radio" name="options" id="rejected" autocomplete="off"> Rejected
    </label>
    <label class="btn btn-outline-success btn-sm" (click)="changeStatus('failed');">
      <input type="radio" name="options" id="failed" autocomplete="off"> Failed
    </label>
    &nbsp;&nbsp;
    <div class="dropdown">
      <button class="btn btn-success dropdown-toggle btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
      aria-expanded="false">
        Sort By
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" href="#">Date Entered</a>
        <a class="dropdown-item" href="#">Amount</a>
        <a class="dropdown-item" href="#">User</a>
      </div>
    </div>
  </div>
</div>

<div *ngFor="let booking of bookingRequests">
  <mat-card appearance="outlined">
    <mat-card-header>
      <div mat-card-avatar class="fa fa-user-circle fa-3x"></div>
      <mat-card-title>
        <h5>({{booking.totalPrice | currency:'USD':'$':'1.2-2'}})</h5>
      </mat-card-title>
      <mat-card-subtitle>
        <div>Booking Id - [{{booking.bookingId}}]</div>
        <div>{{booking.customerDescription}} - [{{booking.customerId}}]</div>
        <div class="button-row">
          <button type="button" class="btn btn-success btn-sm">Approve</button>
          <button type="button" class="btn btn-success btn-sm" (click)="modifyBooking(booking)">Modify</button>
          <button type="button" class="btn btn-danger btn-sm">Decline</button>
        </div>
      </mat-card-subtitle>
    </mat-card-header>
  </mat-card>
  <br>
</div>